import React, { useState } from 'react';
import { Upload, Globe } from 'lucide-react';
import { Button } from '@mellify/ui';
import { UploadDocumentsModal } from './knowledge/components/UploadDocumentsModal';
import { AddURLModal } from './knowledge/components/AddURLModal';

/**
 * KnowledgePageActions
 *
 * Rendered in the DashboardLayout page header for the Knowledge Base page.
 * Opens the Upload Documents modal when the upload button is clicked.
 * Opens the Add URL modal when the URL button is clicked.
 */
export const KnowledgePageActions: React.FC = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [isAddUrlOpen, setIsAddUrlOpen] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        leftIcon={<Globe className="w-4 h-4" />}
        onClick={() => setIsAddUrlOpen(true)}
      >
        Add URL
      </Button>
      <Button
        variant="primary"
        size="sm"
        leftIcon={<Upload className="w-4 h-4" />}
        onClick={() => setIsUploadOpen(true)}
      >
        Upload Documents
      </Button>

      <UploadDocumentsModal
        open={isUploadOpen}
        onClose={() => setIsUploadOpen(false)}
      />
      <AddURLModal
        open={isAddUrlOpen}
        onClose={() => setIsAddUrlOpen(false)}
      />
    </>
  );
};

KnowledgePageActions.displayName = 'KnowledgePageActions';